import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TablePartnerCharge from "./components/TablePartnerCharge";

export default function PartnerChargeListPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TablePartnerCharge />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}
